// Given a path as an array (e.g. ['documentRoot', 'paragraph1', 'sentence2']) collapse it to a single string with the
// separated by / (e.g. 'documentRoot/paragraph1/sentence2')
export default function collapseParentPath(parentPath: string[]): string {
    return parentPath.join('/');
}
